import Signal from '../primitives/signal'
import modalsEventBus from './modals-event-bus'

export default function showModal(createModalContent: (closeSignal: Signal) => React.ReactNode) {
  const closeSignal = new Signal()
  const content = createModalContent(closeSignal)

  modalsEventBus.emit('show', { content, id: crypto.randomUUID(), closeSignal })
}
